import { render, staticRenderFns } from "./SubjectMicroscopyTemplate.vue?vue&type=template&id=4a3dc3bc&scoped=true&"
import script from "./SubjectMicroscopyTemplate.vue?vue&type=script&lang=js&"
export * from "./SubjectMicroscopyTemplate.vue?vue&type=script&lang=js&"
import style0 from "./SubjectMicroscopyTemplate.vue?vue&type=style&index=0&id=4a3dc3bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3dc3bc",
  null
  
)

export default component.exports